// Session behaviour shared by every portal screen.

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { SESSION_EXPIRED, clearClientToken } from "../../api/clientPortal";

/**
 * Clearing the cache is not tidiness: the portal is meant for shared and
 * borrowed devices, so the next client must not be handed the previous
 * one's case out of memory.
 */
export function usePortalSignOut(): () => void {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return () => {
    clearClientToken();
    queryClient.clear();
    navigate("/portal/login", { replace: true });
  };
}

/**
 * A day-old token is the ordinary way back, not a failure worth a message -
 * requireClient answers 401 and the client simply signs in again.
 */
export function useExpiredSession(error: unknown): boolean {
  const navigate = useNavigate();
  const expired = error instanceof Error && error.message === SESSION_EXPIRED;

  useEffect(() => {
    if (expired) navigate("/portal/login", { replace: true });
  }, [expired, navigate]);

  return expired;
}
